export { default as courseCategoryFragment } from './course-category-fragment';
export { default as createOneCourseCategoryMutation } from './create-one-course-category-mutation';
export { default as findByCourseAndIndexCourseCategoryQuery } from './find-by-course-and-index-course-category-query';
export { default as findByIdCourseCategoryQuery } from './find-by-id-course-category-query';
export { default as findManyCourseCategoryQuery } from './find-many-course-category-query';
export { default as removeByIdCourseCategoryMutation } from './remove-by-id-course-category-mutation';
export { default as updateOrderCourseCategoryMutation } from './update-order-course-category-mutation';
